const viewAny = (permissions) => {
  return permissions.includes('read-business-activities')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-business-activities')
}

const update = (permissions) => {
  return hasPermission(permissions, 'update-business-activities')
}

const deletee = (permissions) => {
  return hasPermission(permissions, 'delete-business-activities')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};